import gql from 'graphql-tag'

export const DISMISS_BANNER_MUTATION = gql`
mutation dismissBanner($bannerId: ID!){
  dismissBanner(bannerId: $bannerId){
    success
  }
}`